import { __assign } from "tslib";
import moment from 'moment';
import { app as api } from '@ekuaibao/whispered';
import { getContentByLocale } from '@ekuaibao/lib/lib/i18n-helpers';
import { isCity, isMoney } from '@ekuaibao/lib/lib/propertySetIs';
var isPayNode = function (node) { return node.name === i18n.get('出纳支付节点') || node.name === '出纳支付'; };
var getStaffShowByConfig = function (value) {
    var name = getDisplayName(value);
    if (!name)
        return '';
    var str = getStaffShowExternal(value);
    return str ? "" + name + str : name;
};
export var getStaffShowExternal = function (staff) {
    var config = api.getState('@common.organizationConfig');
    if (!config.applyToGlobal) {
        return '';
    }
    return getStaffShowValue(staff, config.staffDisplayConfig);
};
export var getDisplayName = function (obj) {
    var label = getContentByLocale(obj, 'label');
    var name = getContentByLocale(obj, 'name');
    return label || name;
};
var isDate = function (propertySet) {
    var _a;
    return ((_a = propertySet === null || propertySet === void 0 ? void 0 : propertySet.dataType) === null || _a === void 0 ? void 0 : _a.type) === 'date';
};
var isText = function (propertySet) {
    var _a;
    return ((_a = propertySet === null || propertySet === void 0 ? void 0 : propertySet.dataType) === null || _a === void 0 ? void 0 : _a.type) === 'text';
};
var isNumber = function (propertySet) {
    var _a;
    return ((_a = propertySet === null || propertySet === void 0 ? void 0 : propertySet.dataType) === null || _a === void 0 ? void 0 : _a.type) === 'number';
};
var getCityValue = function (customPropertyData) {
    try {
        var dataArr = JSON.parse(customPropertyData);
        return dataArr.map(function (c) { return c.label; }).join(',');
    }
    catch (_a) {
        return '';
    }
};
var getMoneyValue = function (customPropertyData) {
    var standardSymbol = customPropertyData.standardSymbol, standard = customPropertyData.standard, standardUnit = customPropertyData.standardUnit;
    return "" + standardSymbol + standard + standardUnit;
};
var getDateValue = function (customPropertyData) {
    return moment(customPropertyData).format('YYYY-MM-DD');
};
var getStaffCustomFieldValues = function (customFieldName, staffId) {
    var _a;
    var allProperties = api.getState('@common.staffProperties') || [];
    var customProperty = allProperties.find(function (p) { return p.name === customFieldName; });
    var value = '';
    if (customProperty) {
        var staffs = api.getState('@common.staffsActives').data || {};
        var staff = staffs.find(function (s) { return s.id === staffId; });
        if (staff) {
            var staffDisplayDimensions = staff.staffDisplayDimensions, staffCustomForm = staff.staffCustomForm;
            var customPropertyData = staffCustomForm === null || staffCustomForm === void 0 ? void 0 : staffCustomForm[customFieldName];
            if (!customPropertyData) {
                return '';
            }
            if (isCity(customProperty)) {
                value = getCityValue(customPropertyData);
            }
            else if (isMoney(customProperty)) {
                value = getMoneyValue(customPropertyData);
            }
            else if (isDate(customProperty)) {
                value = getDateValue(customPropertyData);
            }
            else if (isText(customProperty)) {
                value = customPropertyData;
            }
            else if (isNumber(customProperty)) {
                value = customPropertyData + ((_a = customProperty.dataType) === null || _a === void 0 ? void 0 : _a.unit) || '';
            }
            else {
                var customPropertyDataRef = staffDisplayDimensions === null || staffDisplayDimensions === void 0 ? void 0 : staffDisplayDimensions[customPropertyData];
                value = getDisplayName({ label: customPropertyDataRef === null || customPropertyDataRef === void 0 ? void 0 : customPropertyDataRef.fullName, name: customPropertyDataRef === null || customPropertyDataRef === void 0 ? void 0 : customPropertyDataRef.enFullName });
            }
        }
    }
    return value;
};
var getStaffShowValue = function (value, staffDisplayConfig) {
    var showValue = '';
    if (staffDisplayConfig.length > 1) {
        var str = staffDisplayConfig[1];
        if (str === 'deptCode') {
            var departmentMapData = api.getState('@common.department.mapData') || {};
            var externalDepartmentMapData = api.getState('@common.externalDepartment.mapData') || {};
            var deptData = __assign(__assign({}, departmentMapData), externalDepartmentMapData);
            var deptId = typeof value.defaultDepartment === 'object' ? value.defaultDepartment.id : value.defaultDepartment;
            if (!deptId) {
                deptId =
                    value.externalDefaultDepartment && typeof value.externalDefaultDepartment === 'object'
                        ? value.externalDefaultDepartment.id
                        : value.externalDefaultDepartment;
            }
            var depValue = deptData[deptId];
            if (depValue) {
                showValue = depValue.code
                    ? "" + i18n.get('（') + depValue.name + "-" + depValue.code + i18n.get('）')
                    : "" + i18n.get('（') + depValue.name + i18n.get('）');
            }
        }
        else {
            if (value) {
                if (value[str]) {
                    showValue = "" + i18n.get('（') + value[str] + i18n.get('）');
                }
                else if (value.staffCustomForm) {
                    var fieldValue = getStaffCustomFieldValues(str, value.id);
                    showValue = fieldValue ? "" + i18n.get('（') + fieldValue + i18n.get('）') : '';
                }
            }
        }
    }
    return showValue;
};
var getStaffExplainValue = function (staff) {
    if (!staff)
        return '';
    var config = api.getState('@common.organizationConfig');
    if (!config.applyToGlobal) {
        return '';
    }
    var str = getStaffShowValue(staff, config.staffDisplayConfig);
    var status = staff.active === false ? "(" + i18n.get('已停用') + ")" : "";
    return "" + str + status;
};
var getDimensionExplainValue = function (dimension) {
    if (!dimension) {
        return '';
    }
    var code = dimension.code;
    return !!code ? "(" + code + ")" : '';
};
export var filterStaff = function (searchKey, staff) {
    return likeMatch(staff.name, searchKey) ||
        likeMatch(staff.nameInitial, searchKey) ||
        likeMatch(staff.nameSpell, searchKey);
};
export var filterDepartment = function (searchKey, department) {
    return likeMatch(department.name, searchKey) ||
        likeMatch(department.nameInitial, searchKey) ||
        likeMatch(department.nameSpell, searchKey);
};
export var likeMatch = function (sourceStr, matchKey) {
    if (!sourceStr) {
        return false;
    }
    return sourceStr.toLowerCase().includes(matchKey === null || matchKey === void 0 ? void 0 : matchKey.toLowerCase());
};
export { isPayNode, getStaffShowValue, getStaffShowByConfig, getStaffExplainValue, getDimensionExplainValue };
